<ng-container *ngIf="isVisible">
    <div [ngClass]="field.panelClass" [id]="field.id + '-container'">
        <span
            class="toggle-text"
            [ngClass]="{ required: isRequired, 'toggle-text-disabled': control.disabled }"
            *ngIf="field.label"
        >
            {{ field.label | translate }}
        </span>
        <mat-slide-toggle
            [id]="field.id"
            [formControl]="control"
            [attr.formcontrolname]="field.name"
            [required]="isRequired"
            (change)="toggleChange($event)"
        >
            {{ field.placeholder | translate }}
        </mat-slide-toggle>
    </div>
</ng-container>
